import { HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { lastValueFrom } from 'rxjs';
import { csvMimeTypes, excelMimeTypes } from '@coin/shared/core/util-models';
import { LoadingService, TransactionService } from '@coin/shared/core/data-access';
import { ImporterBaseService } from '../../shared/services/importer-base.service';
import { ImporterName } from '../../interfaces/enums/importer-name.enum';

@Injectable({ providedIn: 'root' })
export class FileUploadService {
  private toast = inject(ToastrService);
  private loadingService = inject(LoadingService);
  private importerService = inject(ImporterBaseService);
  private transactionService = inject(TransactionService);

  public async uploadSingleFile(
    file: File,
    importerName: ImporterName,
    metadata?: Record<string, string>,
    withTransaction?: false
  ): Promise<void>;
  public async uploadSingleFile(
    file: File,
    importerName: ImporterName,
    metadata?: Record<string, string>,
    withTransaction?: true
  ): Promise<string>;
  public async uploadSingleFile(
    file: File,
    importerName: ImporterName,
    metadataParam?: Record<string, string>,
    withTransaction = false
  ): Promise<void | string> {
    let metadata = metadataParam;
    if (!file) return;
    if (!metadata) metadata = {};

    try {
      if (![...excelMimeTypes, ...csvMimeTypes].includes(file.type)) {
        this.toast.error('Filetype is not supported.');
        return;
      }

      this.loadingService.present();

      if (withTransaction) {
        const transaction = await lastValueFrom(this.transactionService.createTransaction());
        metadata.transactionId = transaction.transactionId;
      }

      await lastValueFrom(
        this.importerService.upload(
          file,
          importerName,
          new HttpParams().set('metadata', JSON.stringify(metadata)),
          withTransaction
        )
      );
      if (withTransaction) /*eslint-disable-line @typescript-eslint/consistent-return*/ return metadata.transactionId;
    } catch (e) {
      console.error(e);
      this.toast.warning('Cannot process upload. Please check your file.');
      this.loadingService.dismiss();
    } finally {
      this.loadingService.dismiss();
    }
  }
}
